import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';
import SeatMap from '../../components/SeatMap/seatnew';
import CanvasSeatMap from '../../components/SeatMap/CanvasSeatMap';
import CanvasSeatMapCanvas from '../../components/SeatMap/CanvasSeatMapCanvas';
import $ from 'jquery';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrash, faArrowLeft, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { getseatingbyId, getSeatingPlan, getEventById } from '../../services/apiService';
import AuthCheck from '../../components/authCheck/AuthCheck';
import Form from '../../components/loginForm/form';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { getEventBySlugFromStorage, createEventSlug, isEventOver } from '../../utils/urlUtils';
import { formatEventDateTimeFromAPI } from '../../utils/timeUtils';
import seatmapimg from '../../assets/images/round table img.jpeg';

const transformSeatMapData = (raw) => {
  return raw.map((seat) => {
    if (seat.type === 'space') {
      return {
        id: seat.id,
        type: 'space',
        row: seat.row,
        section: seat.section,
        status: 'space',
      };
    }
    return {
      id: seat.id,
      row: seat.row,
      number: parseInt(seat.label, 10),
      status: seat.reserved === true ? 'booked' : 'available',
      section: seat.section,
      price: seat.price,
      childprice: seat.childprice,
      type: 'seat',
      color: seat.color // preserve API-provided color
    };
  });
};

const transformApiSeatData = (apiData) => {
  // Get the last seating plan from the API data array
  const lastSeatingPlan = Array.isArray(apiData) ? apiData[apiData.length - 1] : apiData;
  if (!lastSeatingPlan) return [];
  console.log(lastSeatingPlan, "lastSeatingPlan");
  const transformedSeats = [];
  lastSeatingPlan.sections.forEach(section => {
    section.rows.forEach(row => {
      row.seats.forEach(seat => {
        // Treat as space if price is null and (level is empty or seatNumber is empty/null)
        if (
          seat.price === null || seat.price === 0 &&
          (seat.level === "" || seat.seatNumber === "" || seat.seatNumber == null)
        ) {
          transformedSeats.push({
            id: seat._id,
            label: '',
            row: section.name,
            type: 'space',
            section: section.name,
            price: null
          });
        } else {
          transformedSeats.push({
            id: seat._id,
            label: seat.seatNumber ? seat.seatNumber.toString() : '',
            number: seat.seatNumber,
            row: section.name,
            type: seat.reserved ? 'booked' : 'seat',
            section: section.name,
            price: seat.price,
            childprice: seat.childprice,
            reserved: seat.reserved,
            color: seat.color // keep API-provided color
          });
        }
      });
    });
  });

  return transformedSeats;
};

// Utility function to safely format dates
const formatEventDateTime = (datetime) => {
  try {
    const eventDate = new Date(datetime);
    if (isNaN(eventDate.getTime())) {
      return 'Date not available';
    }

    // Format date
    const dateStr = eventDate.toLocaleDateString();

    // Format time in 12-hour format with AM/PM
    const timeStr = eventDate.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });

    return `${dateStr} • ${timeStr}`;
  } catch (error) {
    return 'Date not available';
  }
};

const BookingPage = () => {
  const { eventName } = useParams();
  const navigate = useNavigate();
  const [seats, setSeats] = useState([]);
  const [roundLayoutData, setRoundLayoutData] = useState(null); // For round layout raw data
  const [selectedSeats, setSelectedSeats] = useState([]);

  // Helper function to extract all seats from round layout data
  const getAllSeatsFromRoundLayout = useCallback((layoutData) => {
    if (!layoutData || !layoutData.sections) return [];
    const allSeats = [];
    layoutData.sections.forEach(section => {
      section.rows.forEach(row => {
        row.seats.forEach(seat => {
          allSeats.push({
            id: seat.id || seat._id,
            tableName: section.name,
            section: section.name, // Use table name as section for round layouts
            row: section.name, // Use table name as row for round layouts (for compatibility)
            number: seat.label || seat.seatNumber || '', // Use label as number
            label: seat.label || seat.seatNumber || '',
            status: seat.reserved ? 'booked' : 'available',
            reserved: seat.reserved || false,
            price: seat.price || 0,
            childprice: seat.childprice || null,
            type: 'seat',
            color: seat.color || '#96CEB4',
            // Store additional round layout specific data
            tableId: section._id || section.id,
            tableType: section.tableType,
            isRoundLayout: true
          });
        });
      });
    });
    return allSeats;
  }, []);

  // Get all seats (normal or round layout)
  const allSeats = useMemo(() => {
    if (roundLayoutData) {
      return getAllSeatsFromRoundLayout(roundLayoutData);
    }
    return seats;
  }, [seats, roundLayoutData, getAllSeatsFromRoundLayout]);
  const [ticketPrefs, setTicketPrefs] = useState(null);
  const [showSeatPrefModal, setShowSeatPrefModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const uniqueSections = [...new Set(allSeats.filter(s => s.type === 'seat').map(s => s.section))];

  const location = useLocation();
  const [eventData, setEventData] = useState(location.state);

  const [selectedBaseSection, setSelectedBaseSection] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [ticketCount, setTicketCount] = useState(1);
  const [maxTicketsForSection, setMaxTicketsForSection] = useState(0);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecked, setAuthChecked] = useState(false);
  const [scrollDirection, setScrollDirection] = useState('down'); // 'down' or 'up'
  const [isMobile, setIsMobile] = useState(false);
  const [pendingConfirmation, setPendingConfirmation] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  const [seatTicketTypes, setSeatTicketTypes] = useState({}); // { seatId: 'adult' | 'child' }
  const [isMobilePanelExpanded, setIsMobilePanelExpanded] = useState(true); // Mobile selection panel expanded state

  // Helper function to get price for a section
  const getSectionPrice = (sectionName) => {
    const seatInSection = allSeats.find(s => s.section === sectionName && s.type === 'seat' && s.price !== null);
    return seatInSection ? seatInSection.price : 0;
  };
  const getSectionChildPrice = (sectionName) => {
    const seatInSection = allSeats.find(s => s.section === sectionName && s.type === 'seat' && s.childprice !== null);
    return seatInSection ? seatInSection.childprice : 0;
  };

  // Helper function to check if a section is available for booking
  const isSectionAvailable = (sectionName) => {
    const sectionSeats = allSeats.filter(s => s.section === sectionName && s.type === 'seat');

    // If no seats found, section is not available
    if (sectionSeats.length === 0) return false;

    // Check if all seats have price 0
    const allPriceZero = sectionSeats.every(s => s.price === 0 || s.price === null);
    if (allPriceZero) return false;

    // Check if all seats are reserved
    const allReserved = sectionSeats.every(s => s.status === 'booked' || s.reserved === true);
    if (allReserved) return false;

    return true;
  };

  // Get available sections only
  const availableSections = uniqueSections.filter(section => isSectionAvailable(section));

  // Helper function to extract base section name (e.g., "Diamond" from "Diamond 2" or "Diamond A")
  const getBaseSectionName = (sectionName) => {
    if (!sectionName) return '';
    // Remove trailing numbers/letters and spaces (e.g., "Diamond 2" -> "Diamond", "Diamond A" -> "Diamond")
    return sectionName.replace(/\s+[\dA-Za-z]+$/, '').trim();
  };

  // Get unique base sections from available sections (preserving API order)
  const getUniqueBaseSections = () => {
    const seen = new Set();
    const uniqueBaseSections = [];
    
    for (const section of availableSections) {
      const baseSection = getBaseSectionName(section);
      if (baseSection && !seen.has(baseSection)) {
        seen.add(baseSection);
        uniqueBaseSections.push(baseSection);
      }
    }
    
    return uniqueBaseSections;
  };

  // Get sections that belong to a base section
  const getSectionsForBaseSection = (baseSection) => {
    if (!baseSection) return [];
    return availableSections.filter(section => {
      const baseName = getBaseSectionName(section);
      return baseName === baseSection;
    });
  };

  // Helper function to get count of available (unreserved) seats in a section
  const getAvailableSeatsCount = (sectionName) => {
    const sectionSeats = allSeats.filter(s =>
      s.section === sectionName &&
      s.type === 'seat' &&
      s.status === 'available' &&
      s.price > 0
    );
    return sectionSeats.length;
  };

  // Get event data from sessionStorage if not available from location.state
  useEffect(() => {
    // First, try to get eventData from bookingData if coming back from confirm page
    const storedBookingData = sessionStorage.getItem('bookingData');
    if (storedBookingData && !eventData) {
      try {
        const bookingData = JSON.parse(storedBookingData);
        if (bookingData.event) {
          setEventData(bookingData.event);
          // Store as selectedEvent for other components
          sessionStorage.setItem("selectedEvent", JSON.stringify(bookingData.event));
          return;
        }
      } catch (error) {
        console.error('Error parsing bookingData:', error);
      }
    }

    if (!eventData && eventName) {
      // Try to find event by slug from storage
      const foundEvent = getEventBySlugFromStorage(eventName);
      if (foundEvent) {
        setEventData(foundEvent);
        // Store as selectedEvent for other components
        sessionStorage.setItem("selectedEvent", JSON.stringify(foundEvent));
      }
    } else if (eventData && (!eventData.id && !eventData._id)) {
      // If eventData exists but doesn't have an id, try to get it from sessionStorage
      const storedEvent = sessionStorage.getItem("selectedEvent");
      if (storedEvent) {
        const parsedStoredEvent = JSON.parse(storedEvent);
        if (parsedStoredEvent.id) {
          // Merge the stored event data with the current event data
          setEventData(prevData => ({
            ...prevData,
            id: parsedStoredEvent.id
          }));
        }
      }
    }
  }, [eventData, eventName]);

  // Cleanup any lingering modal backdrops on mount and unmount
  useEffect(() => {
    // Clean up any existing modal backdrops on mount
    const existingBackdrops = document.querySelectorAll('.modal-backdrop');
    existingBackdrops.forEach(backdrop => backdrop.remove());
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    // Cleanup function for when component unmounts
    return () => {
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    };
  }, []);

  // Detect mobile device
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Handle scroll direction for arrow
  useEffect(() => {
    const handlePageScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      // If at bottom of page, show up arrow, otherwise show down arrow
      const atBottom = scrollTop + clientHeight >= scrollHeight - 100;
      setScrollDirection(atBottom ? 'up' : 'down');
    };

    window.addEventListener('scroll', handlePageScroll);
    handlePageScroll(); // Check initial position

    return () => window.removeEventListener('scroll', handlePageScroll);
  }, []);

  // Function to handle scroll
  const handleScrollClick = () => {
    if (scrollDirection === 'down') {
      // Scroll down
      window.scrollBy({
        top: 400,
        behavior: 'smooth'
      });
    } else {
      // Scroll up
      window.scrollBy({
        top: -400,
        behavior: 'smooth'
      });
    }
  };

  // Check authentication when component mounts
  useEffect(() => {
    const checkAuthentication = () => {
      const user = localStorage.getItem('user');
      const token = localStorage.getItem('accessToken');

      if (user && token) {
        console.log('User authenticated');
        setIsAuthenticated(true);
      } else {
        console.log('User not authenticated');
        setIsAuthenticated(false);
      }
      // Show ticket selection modal for all users (authenticated or not)
      // setShowSeatPrefModal(true); // REMOVED: Explore first UX
      setAuthChecked(true);
    };

    // Check auth when component mounts
    checkAuthentication();
  }, []);

  const fetchSeatingPlan = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const eventDataToUse = eventData || JSON.parse(sessionStorage.getItem("selectedEvent"));
      if (!eventDataToUse?.seatingPlan) {
        setError('Event data not found. Please return to the event page.');
        return;
      }

      const seatingPlan = eventDataToUse.seatingPlan;
      console.log('Fetching seating plan for:', seatingPlan);

      // Direct API call
      const response = await getseatingbyId(seatingPlan);

      // Get the last seating plan from the array
      const apiData = response;
      const lastSeatingPlan = Array.isArray(apiData) ? apiData[apiData.length - 1] : apiData;
      
      // Check if it's a round layout (includes both round and rectangular tables) - if so, store raw data separately
      if (lastSeatingPlan && (lastSeatingPlan.type === 'round' || 
          (lastSeatingPlan.sections && lastSeatingPlan.sections.length > 0 && 
           (lastSeatingPlan.sections[0]?.tableType === 'round' || lastSeatingPlan.sections[0]?.tableType === 'rectangular')))) {
        // For round layouts, store raw data separately and keep seats as empty array
        setRoundLayoutData(lastSeatingPlan);
        setSeats([]); // Keep seats as array to avoid errors
      } else {
        // For normal layouts, transform the data as before
        setRoundLayoutData(null); // Clear round layout data
        const transformedApiData = transformApiSeatData(apiData);
        const transformed = transformSeatMapData(transformedApiData);
        setSeats(transformed);
      }
    } catch (err) {
      console.error('Error fetching seating plan:', err);
      console.error('Error message:', err.message);

      // If we get here, show the generic error
      console.log('Showing generic error message');
      setError('Failed to load seating plan. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to show authentication modal
  const displayAuthModal = () => {
    console.log('Setting showAuthModal to true');
    console.log('Current showAuthModal state:', showAuthModal);

    // Close ticket selection modal when showing auth modal
    setShowSeatPrefModal(false);
    setShowAuthModal(true);
    console.log('showAuthModal state should now be true');

    // Fallback: also try to show modal directly via DOM manipulation
    setTimeout(() => {
      const modalElement = document.getElementById('bookingAuthModal');
      if (modalElement && !modalElement.classList.contains('show')) {
        console.log('Fallback: showing modal via DOM manipulation');
        modalElement.classList.add('show', 'd-block');
        modalElement.setAttribute('aria-modal', 'true');
        modalElement.setAttribute('role', 'dialog');
        document.body.classList.add('modal-open');
      }
    }, 100);
  };

  const handleLoginSuccess = () => {
    // Close modal and update authentication state
    console.log('Login successful, closing auth modal');
    setShowAuthModal(false);
    setIsAuthenticated(true);

    // Only show ticket selection modal if no seats are selected AND we are not pending confirmation
    // REMOVED: Explore first UX - don't auto show modal
    /*
    if (selectedSeats.length === 0 && !pendingConfirmation) {
      setTimeout(() => {
        setShowSeatPrefModal(true);
      }, 500);
    }
    */

    // We can re-fetch seating plan to ensure we have latest data (e.g. user specific pricing if any)
    fetchSeatingPlan();
  };

  useEffect(() => {
    if (eventData && authChecked) {
      fetchSeatingPlan();
    }
  }, [eventName, eventData, authChecked]);

  // Restore selected seats from bookingData in sessionStorage when returning from confirm page
  useEffect(() => {
    const storedBookingData = sessionStorage.getItem('bookingData');
    // Only restore if we have booking data, seats are loaded, no seats are currently selected, and no ticket prefs set
    // This prevents restoration after user clears selection
    if (storedBookingData && allSeats.length > 0 && selectedSeats.length === 0 && !ticketPrefs) {
      try {
        const bookingData = JSON.parse(storedBookingData);
        if (bookingData.selectedSeats && Array.isArray(bookingData.selectedSeats)) {
          // Restore selected seats by matching seat IDs
          const seatIds = bookingData.selectedSeats.map(seat => seat.id);
          const validSeatIds = seatIds.filter(seatId => 
            allSeats.some(seat => seat.id === seatId && seat.status === 'available')
          );
          
          if (validSeatIds.length > 0) {
            setSelectedSeats(validSeatIds);
            
            // Also restore ticket preferences based on selected seats
            const preferencesBySection = {};
            validSeatIds.forEach(seatId => {
              const seat = allSeats.find(s => s.id === seatId);
              if (seat) {
                preferencesBySection[seat.section] = (preferencesBySection[seat.section] || 0) + 1;
              }
            });
            
            if (Object.keys(preferencesBySection).length > 0) {
              setTicketPrefs(preferencesBySection);
            }

            // Restore ticket types if available
            if (bookingData.seatTicketTypes) {
              setSeatTicketTypes(bookingData.seatTicketTypes);
            } else if (bookingData.selectedSeats) {
              // Fallback: restore from seat.ticketType if available
              const restoredTicketTypes = {};
              bookingData.selectedSeats.forEach(seat => {
                if (seat.ticketType && validSeatIds.includes(seat.id)) {
                  restoredTicketTypes[seat.id] = seat.ticketType;
                }
              });
              if (Object.keys(restoredTicketTypes).length > 0) {
                setSeatTicketTypes(restoredTicketTypes);
              }
            }
          }
        }
      } catch (error) {
        console.error('Error restoring booking data:', error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSeats, selectedSeats.length, ticketPrefs]);

  // Listen for login events
  useEffect(() => {
    const handleUserLogin = () => {
      // Update authentication state and retry fetching seating plan
      console.log('User login event received');
      setIsAuthenticated(true);
      setShowAuthModal(false);

      // Only show ticket selection modal if no seats are selected
      // We need to check selectedSeats here, but it's a closure. 
      // However, if we are pending confirmation, we definitely don't want to show it.
      // Since we can't easily access current selectedSeats without adding it to dependency (which might re-attach listener often),
      // we can rely on the fact that if this event fires, it might be from a different component.
      // But for this specific flow, handleLoginSuccess covers the modal case.
      // Let's just NOT show the seat pref modal here unconditionally.

      fetchSeatingPlan();
    };

    window.addEventListener('userLogin', handleUserLogin);
    return () => window.removeEventListener('userLogin', handleUserLogin);
  }, [eventData]);

  // Handle pending confirmation after login
  useEffect(() => {
    if (isAuthenticated && pendingConfirmation) {
      console.log('User authenticated and pending confirmation, showing confirm modal');
      setPendingConfirmation(false);

      // Show confirm modal
      setTimeout(() => {
        const modalElement = document.getElementById('confirmModal');
        if (modalElement) {
          const modal = new bootstrap.Modal(modalElement);
          modal.show();
        }
      }, 500); // Small delay to allow auth modal to close completely
    }
  }, [isAuthenticated, pendingConfirmation]);

  useEffect(() => {
    // No auto-selection here
  }, [ticketPrefs]);

  // Clear validation error when seat selection changes (user is fixing the issue)
  useEffect(() => {
    if (validationError && selectedSeats.length > 0) {
      // Re-validate to see if error is resolved
      if (ticketPrefs && Object.keys(ticketPrefs).length > 0) {
        const selectedSeatsBySection = {};
        selectedSeatDetails.forEach(seat => {
          selectedSeatsBySection[seat.section] = (selectedSeatsBySection[seat.section] || 0) + 1;
        });

        let allComplete = true;
        for (const [section, requiredCount] of Object.entries(ticketPrefs)) {
          const selectedCount = selectedSeatsBySection[section] || 0;
          if (selectedCount < requiredCount) {
            allComplete = false;
            break;
          }
        }

        if (allComplete) {
          setValidationError(null);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSeats, ticketPrefs]);

  // Handle modal backdrop when showAuthModal changes
  useEffect(() => {
    console.log('showAuthModal changed to:', showAuthModal);
    if (showAuthModal) {
      document.body.classList.add('modal-open');
      console.log('Added modal-open class to body');
    } else {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      // Clean up any stray backdrops
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
      console.log('Removed modal-open class from body');
    }
  }, [showAuthModal]);

  // Handle modal backdrop when showSeatPrefModal changes
  useEffect(() => {
    if (showSeatPrefModal && !showAuthModal) {
      document.body.classList.add('modal-open');
    } else if (!showSeatPrefModal && !showAuthModal) {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      // Clean up any stray backdrops
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
    }
  }, [showSeatPrefModal, showAuthModal]);

  // Handle modal backdrop when showContactModal changes
  useEffect(() => {
    if (showContactModal && !showAuthModal && !showSeatPrefModal) {
      document.body.classList.add('modal-open');
    } else if (!showContactModal && !showAuthModal && !showSeatPrefModal) {
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      // Clean up any stray backdrops
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
    }
  }, [showContactModal, showAuthModal, showSeatPrefModal]);

  // Ensure modal is properly initialized
  useEffect(() => {
    const modalElement = document.getElementById('bookingAuthModal');
    if (modalElement) {
      console.log('Auth modal element found on mount');
    } else {
      console.log('Auth modal element not found on mount');
    }
  }, []);

  // Helper function to get seats in a row (or table for round layouts)
  const getSeatsInRow = (row, section) => {
    const rowSeats = allSeats
      .filter(seat => seat.row === row && seat.section === section && seat.type === 'seat')
      .sort((a, b) => {
        // For round layouts, sort by label/number if available
        if (a.isRoundLayout) {
          const aNum = parseInt(a.label || a.number || '0', 10);
          const bNum = parseInt(b.label || b.number || '0', 10);
          return aNum - bNum;
        }
        return a.number - b.number;
      });

    console.log(`Getting seats for row ${row}, section ${section}:`, rowSeats);
    return rowSeats;
  };

  // Helper function to check if seats are contiguous
  const areSeatsContiguous = (seats) => {
    if (seats.length <= 1) return true;

    // Sort seats by number
    const sortedSeats = [...seats].sort((a, b) => a.number - b.number);

    // Check if numbers are consecutive
    for (let i = 1; i < sortedSeats.length; i++) {
      if (sortedSeats[i].number !== sortedSeats[i - 1].number + 1) {
        return false;
      }
    }
    return true;
  };

  // Helper function to check if selection would create orphan seats
  const wouldCreateOrphanSeats = (selectedSeatIds, seatsArray) => {
    // Get all seats in the same row and section as the first selected seat
    const firstSeat = seatsArray.find(s => s.id === selectedSeatIds[0]);
    if (!firstSeat) return false;

    const rowSeats = getSeatsInRow(firstSeat.row, firstSeat.section);

    // Find the leftmost and rightmost selected seats
    const selectedSeatDetails = selectedSeatIds.map(id => seatsArray.find(s => s.id === id));
    const sortedSelected = selectedSeatDetails.sort((a, b) => {
      // Handle both normal and round layouts
      const aNum = parseInt(a.number || a.label || '0', 10);
      const bNum = parseInt(b.number || b.label || '0', 10);
      return aNum - bNum;
    });
    const leftmost = sortedSelected[0];
    const rightmost = sortedSelected[sortedSelected.length - 1];

    // Check for orphan seats on the left
    const leftSeats = rowSeats.filter(s => {
      const sNum = parseInt(s.number || s.label || '0', 10);
      const leftNum = parseInt(leftmost.number || leftmost.label || '0', 10);
      return sNum < leftNum && s.status === 'available';
    });
    if (leftSeats.length === 1) return true;

    // Check for orphan seats on the right
    const rightSeats = rowSeats.filter(s => {
      const sNum = parseInt(s.number || s.label || '0', 10);
      const rightNum = parseInt(rightmost.number || rightmost.label || '0', 10);
      return sNum > rightNum && s.status === 'available';
    });
    if (rightSeats.length === 1) return true;

    return false;
  };

  // Helper function to get contiguous seats
  const getContiguousSeats = (seat, count) => {
    console.log('Finding contiguous seats for:', seat, 'count:', count);

    const rowSeats = getSeatsInRow(seat.row, seat.section);
    const availableSeats = rowSeats.filter(s => s.status === 'available');
    const seatIndex = availableSeats.findIndex(s => s.id === seat.id);

    if (seatIndex === -1) {
      console.log('Clicked seat not found in available seats');
      return [];
    }

    // Try to find contiguous seats in both directions
    let bestSelection = [];
    let bestScore = -1;

    // Try each possible starting position
    for (let start = 0; start <= availableSeats.length - count; start++) {
      const selection = availableSeats.slice(start, start + count);

      // Skip if selection would create orphan seats (only for normal layouts)
      if (!seat.isRoundLayout && wouldCreateOrphanSeats(selection.map(s => s.id), allSeats)) {
        console.log('Skipping selection that would create orphan seats');
        continue;
      }

      // Calculate how close this selection is to the clicked seat
      const score = -Math.abs(start - seatIndex);

      if (score > bestScore) {
        bestScore = score;
        bestSelection = selection;
      }
    }

    console.log('Best selection found:', bestSelection);
    return bestSelection;
  };
const [autoSeatMode, setAutoSeatMode] = useState(false);

const autoAssignSeats = () => {
  const seatsToAssign = [];

  const data = roundLayoutData || seats;
  if (!data || !data.sections) return;

  Object.entries(ticketPrefs).forEach(([sectionName, count]) => {
    const section = data.sections.find(s => s.name === sectionName);
    if (!section) return;

    const availableSeats = [];

    section.rows.forEach(row => {
      row.seats.forEach(seat => {
        if (!seat.reserved) {
          availableSeats.push(seat);
        }
      });
    });

    seatsToAssign.push(...availableSeats.slice(0, count));
  });

  // Set selected seats programmatically
  setSelectedSeats(
    seatsToAssign.map(seat => seat._id)
  );

  // Clear ticket types for newly selected seats
  setSeatTicketTypes(prev => {
    const updated = { ...prev };
    seatsToAssign.forEach(s => delete updated[s._id]);
    return updated;
  });
};
  // Only select a new block, never toggle individual seats
  const toggleSeat = (seatId) => {
    console.log('Attempting to toggle seat:', seatId);
    console.log('Current ticket preferences:', ticketPrefs);

    const seat = allSeats.find((s) => s.id === seatId);
    if (!seat) {
      console.log('Seat not found');
      return;
    }
     if (autoSeatMode && seat.isRoundLayout) {
    console.log('Auto seat mode active – round table seat click blocked');
    return;
  }

    if (seat.type !== 'seat') {
      console.log('Not a selectable seat type');
      return;
    }

    if (seat.status !== 'available') {
      console.log('Seat is not available');
      return;
    }

    const sectionTicketCount = ticketPrefs?.[seat.section];
    console.log('Section ticket count:', sectionTicketCount, 'for section:', seat.section);

    if (!sectionTicketCount || sectionTicketCount <= 0) {
      console.log('No tickets selected for this section, prompting user');
      // On mobile, don't show modal - user can use the "Choose Your Tickets" button instead
      if (isMobile) {
        return;
      }
      // Auto-select the section and show modal (desktop only)
      const baseSection = getBaseSectionName(seat.section);
      setSelectedBaseSection(baseSection);
      setSelectedSection(seat.section);
      const maxSeats = getAvailableSeatsCount(seat.section);
      setMaxTicketsForSection(maxSeats);
      setTicketCount(1); // Default to 1
      setShowSeatPrefModal(true);
      return;
    }

    // For round layouts, select individual seats starting from the clicked seat
    if (seat.isRoundLayout) {
      // Get all available seats in the same table/section
      const tableSeats = getSeatsInRow(seat.row, seat.section);
      const availableSeats = tableSeats.filter(s => s.status === 'available');
      
      if (availableSeats.length < sectionTicketCount) {
        console.log('Not enough available seats in table');
        return;
      }

      // Find the clicked seat's index in the available seats array
      const clickedSeatIndex = availableSeats.findIndex(s => s.id === seat.id);
      
      if (clickedSeatIndex === -1) {
        console.log('Clicked seat not found in available seats');
        return;
      }

      // Select seats starting from the clicked seat, going forward
      // If we reach the end, wrap around to the beginning
      const seatsToSelect = [];
      for (let i = 0; i < sectionTicketCount; i++) {
        const index = (clickedSeatIndex + i) % availableSeats.length;
        seatsToSelect.push(availableSeats[index]);
      }
      
      console.log('Selecting seats starting from clicked seat:', seat.label || seat.number, 'Seats to select:', seatsToSelect.map(s => s.label || s.number));
      
      // Clear any existing selections in other sections
      const otherSectionSeats = selectedSeats.filter(id => {
        const s = allSeats.find(seat => seat.id === id);
        return s && s.section !== seat.section;
      });

      const newSelection = [...otherSectionSeats, ...seatsToSelect.map(s => s.id)];
      console.log('Setting new selection for round layout:', newSelection);
      setSelectedSeats(newSelection);
      // Clear ticket types for newly selected seats (user needs to choose)
      setSeatTicketTypes(prev => {
        const updated = { ...prev };
        seatsToSelect.forEach(s => {
          delete updated[s.id];
        });
        return updated;
      });
      return;
    }

    // For normal layouts, use existing contiguous seat logic
    // Get seats in the same row and section
    const rowSeats = getSeatsInRow(seat.row, seat.section);
    const availableSeats = rowSeats.filter(s => s.status === 'available');
    console.log('Available seats in row:', availableSeats.length);

    // If there aren't enough available seats in the row, return
    if (availableSeats.length < sectionTicketCount) {
      console.log('Not enough available seats in row');
      return;
    }

    // Get the best contiguous seat selection
    const seatsToSelect = getContiguousSeats(seat, sectionTicketCount);
    console.log('Found seats to select:', seatsToSelect);

    if (seatsToSelect.length === sectionTicketCount) {
      // Clear any existing selections in other sections
      const otherSectionSeats = selectedSeats.filter(id => {
        const s = allSeats.find(seat => seat.id === id);
        return s && s.section !== seat.section;
      });

      const newSelection = [...otherSectionSeats, ...seatsToSelect.map(s => s.id)];
      console.log('Setting new selection:', newSelection);
      setSelectedSeats(newSelection);
      // Clear ticket types for newly selected seats (user needs to choose)
      setSeatTicketTypes(prev => {
        const updated = { ...prev };
        seatsToSelect.forEach(s => {
          delete updated[s.id];
        });
        return updated;
      });
    } else {
      console.log('No suitable contiguous seats found');
    }
  };

  const handleAddTicket = () => {
    const count = Number(ticketCount);
    if (!selectedSection || !count || count < 1) return;

    // Validate ticket count doesn't exceed available seats
    const maxAvailable = getAvailableSeatsCount(selectedSection);
    const validatedCount = Math.min(count, maxAvailable);

    console.log('Adding ticket before:', { section: selectedSection, count: validatedCount, currentPrefs: ticketPrefs });

    setTicketPrefs(prev => {
      const newPrefs = {
        ...prev,
        [selectedSection]: validatedCount
      };
      console.log('New ticket preferences:', newPrefs);
      return newPrefs;
    });

    // Reset all selection states
    setSelectedBaseSection('');
    setSelectedSection('');
    setTicketCount(1);
    setMaxTicketsForSection(0);
  };

  const handleRemoveTicket = (section) => {
    console.log('Removing ticket for section:', section);
    setTicketPrefs(prev => {
      const updated = { ...prev };
      delete updated[section];
      console.log('Updated preferences after removal:', updated);
      return updated;
    });
  };

  const handlePrefsSave = () => {
    // Clear validation error when preferences are updated
    setValidationError(null);

    // If we already have ticket preferences, use them
    if (ticketPrefs && Object.keys(ticketPrefs).length > 0) {
      console.log('Using existing ticket preferences:', ticketPrefs);
      setShowSeatPrefModal(false);
      setSelectedSeats([]); // Clear selection when new prefs are set
      // Reset selection states
      setSelectedBaseSection('');
      setSelectedSection('');
      setAutoSeatMode(true);
      setTicketCount(1);
      setMaxTicketsForSection(0);
      autoAssignSeats();
      return;
    }



    // Otherwise, try to get preferences from the form
    if (selectedSection && ticketCount > 0) {
      const prefs = { [selectedSection]: ticketCount };
      console.log('Setting ticket preferences from form:', prefs);
      setTicketPrefs(prefs);
      setShowSeatPrefModal(false);
      setSelectedSeats([]); // Clear selection when new prefs are set
      // Reset selection states
      setSelectedBaseSection('');
      setSelectedSection('');
      setTicketCount(1);
      setMaxTicketsForSection(0);
    } else {
      console.log('No valid ticket preferences selected');
      // You might want to show an error message to the user here
    }
  };

  const clearSelection = () => {
    setSelectedSeats([]);
    setTicketPrefs(null);
    setSeatTicketTypes({});
      setAutoSeatMode(false);
    // Clear bookingData from sessionStorage when clearing selection
    sessionStorage.removeItem('bookingData');
  };
  const getSeatDetails = (id) => allSeats.find((s) => s.id === id);
  const selectedSeatDetails = selectedSeats.map(getSeatDetails).filter(Boolean);
  const totalCost = selectedSeatDetails.reduce((acc, seat) => {
    // const ticketType = seatTicketTypes[seat.id] || 'adult';
    const ticketType = seatTicketTypes[seat.id];

    const price = ticketType === 'child' && seat.childprice !== undefined && seat.childprice !== null
      ? seat.childprice
      : seat.price || 0;
    return acc + price;
  }, 0);

  // Handler for ticket type changes
  const handleTicketTypeChange = (seatId, ticketType) => {
    // If changing to child, check if this would result in all tickets being child
    if (ticketType === 'child') {
      const updatedTicketTypes = {
        ...seatTicketTypes,
        [seatId]: ticketType
      };
      
      // Get all seats that have ticket types assigned (including this change)
      const seatsWithTypes = selectedSeatDetails.filter(seat => updatedTicketTypes[seat.id]);
      
      // Only check if we have multiple seats and all typed seats would be child
      if (seatsWithTypes.length === selectedSeatDetails.length && selectedSeatDetails.length > 0) {
        // All seats have types - check if all are child
        const allTicketTypes = selectedSeatDetails.map(seat => updatedTicketTypes[seat.id]);
        const allAreChild = allTicketTypes.every(type => type === 'child');
        
        if (allAreChild) {
          setValidationError('At least one adult ticket must be selected. You cannot select all child tickets.');
          // Scroll to top on mobile to show error
          if (isMobile) {
            setTimeout(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);
          }
          // Don't update the state - prevent the change
          return;
        }
      }
    }
    
    // Clear validation error if it was set and we're making a valid change
    if (validationError && validationError.includes('adult ticket')) {
      setValidationError(null);
    }
    
    setSeatTicketTypes(prev => ({
      ...prev,
      [seatId]: ticketType
    }));
  };

  // Validation function to check if all required seats are selected
  const validateSeatSelection = () => {
    if (!ticketPrefs || Object.keys(ticketPrefs).length === 0) {
      return { isValid: false, message: 'Please choose your ticket preferences first.' };
    }

    // Count selected seats by section
    const selectedSeatsBySection = {};
    selectedSeatDetails.forEach(seat => {
      selectedSeatsBySection[seat.section] = (selectedSeatsBySection[seat.section] || 0) + 1;
    });

    // Check if all required seats are selected
    const missingSections = [];
    for (const [section, requiredCount] of Object.entries(ticketPrefs)) {
      const selectedCount = selectedSeatsBySection[section] || 0;
      if (selectedCount < requiredCount) {
        const missing = requiredCount - selectedCount;
        missingSections.push(`${section}: ${missing} seat${missing > 1 ? 's' : ''} missing`);
      }
    }

    if (missingSections.length > 0) {
      // Create a concise message for toast with section names and counts
      const sectionMessages = [];
      for (const [section, requiredCount] of Object.entries(ticketPrefs)) {
        const selectedCount = selectedSeatsBySection[section] || 0;
        if (selectedCount < requiredCount) {
          const missing = requiredCount - selectedCount;
          sectionMessages.push(`${section}: ${missing} seat${missing > 1 ? 's' : ''}`);
        }
      }
      return {
        isValid: false,
        message: `Please select all required seats: ${sectionMessages.join(', ')}`
      };
    }

    // Check if all selected seats have ticket types assigned
    const seatsWithoutTicketType = selectedSeatDetails.filter(seat => !seatTicketTypes[seat.id]);
    if (seatsWithoutTicketType.length > 0) {
      return {
        isValid: false,
        message: 'Please select ticket type (Adult/Child) for all seats before confirming booking.'
      };
    }

    // Check if all tickets are child tickets - at least one adult must be selected
    const allTicketTypes = selectedSeatDetails.map(seat => seatTicketTypes[seat.id]);
    const allAreChild = allTicketTypes.every(type => type === 'child');
    if (allAreChild && selectedSeatDetails.length > 0) {
      return {
        isValid: false,
        message: 'At least one adult ticket must be selected. You cannot select all child tickets.'
      };
    }

    return { isValid: true, message: '' };
  };

  const confirmBooking = () => {
    // Use the same slug from the current URL to maintain consistency
    console.log('EventData in confirmBooking:', eventData);
    console.log('EventData._id:', eventData._id);
    console.log('EventData.id:', eventData.id);
    console.log('Current eventName from URL:', eventName);

    // Include ticket types in seat data
    const selectedSeatsWithTicketTypes = selectedSeatDetails.map(seat => ({
      ...seat,
      ticketType: seatTicketTypes[seat.id] || 'adult'
    }));

    const bookingData = {
      event: eventData,
      selectedSeats: selectedSeatsWithTicketTypes,
      totalCost,
      eventId: eventData.id || eventData._id,
      seatTicketTypes,
    };

    console.log('BookingData being saved:', bookingData);
    sessionStorage.setItem('bookingData', JSON.stringify(bookingData));
    document.getElementById('confirmModal')?.classList.remove('show');
    document.body.classList.remove('modal-open');
    document.querySelector('.modal-backdrop')?.remove();
    document.body.style.overflow = 'auto';
    navigate(`/confirm-booking/${eventName}`, { state: bookingData });
  };

  const handleConfirmBookingClick = () => {
    // Clear any previous validation errors
    setValidationError(null);

    // Validate seat selection first
    const validation = validateSeatSelection();
    if (!validation.isValid) {
      setValidationError(validation.message);
      // Scroll to top to show the error message
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (!isAuthenticated) {
      console.log('User not authenticated, showing login modal before booking');
      setPendingConfirmation(true);
      displayAuthModal();
    } else {
      // Show confirm modal
      const modalElement = document.getElementById('confirmModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    }
  };

  if (!eventData) {
    return (
      <div className="container py-5">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <h4 className="text-muted mb-3">Event data not found</h4>
            <p className="text-muted mb-4">Please return to the event page to continue booking.</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate(`/events/${eventName}`)}
            >
              Back to Event
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Check if event is over
  if (isEventOver(eventData.datetime)) {
    return (
      <div className="container py-5">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <h4 className="text-warning mb-3">Event Has Ended</h4>
            <p className="text-muted mb-4">Sorry, this event has already taken place and booking is no longer available.</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate(`/events/${eventName}`)}
            >
              View Event Details
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="container py-5">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading seating plan...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-5">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
          <div className="text-center">
            <h4 className="text-danger mb-3">Error Loading Seating Plan</h4>
            <p className="text-muted mb-4">{error}</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate(`/events/${eventName}`)}
            >
              Back to Event
            </button>
          </div>
        </div>
      </div>
    );
  }

  const { title, datetime, venue, image, seatingPlan } = eventData;

  return (
    <>
      <section className={`container-fluid container-xxl px-md-5 py-md-5 py-4 ${isMobile && selectedSeatDetails.length > 0 ? 'has-mobile-sticky-buttons' : ''}`}>
        <a className="btn btn-link mb-4" onClick={() => navigate(`/events/${eventName}`)} style={{ width: 'fit-content' }}>
          <svg className='pe-1' width='1.125rem' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M512 256A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM215 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-71 71L392 232c13.3 0 24 10.7 24 24s-10.7 24-24 24l-214.1 0 71 71c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L103 273c-9.4-9.4-9.4-24.6 0-33.9L215 127z" /></svg> Back to Event
        </a>

        {/* Validation Error Toast Notification */}
        {validationError && (
          <div className="validation-toast">
            <div className="validation-toast-content">
              <span className="validation-toast-message">{validationError}</span>
              <button
                type="button"
                className="validation-toast-close"
                onClick={() => setValidationError(null)}
                aria-label="Close"
              >
                ×
              </button>
            </div>
          </div>
        )}

        <div className="row pb-md-5">
          <div className="col-md-7 border-end mb-md-0 mb-5 seatmap-div-container">
            <h2>Book Your Seats</h2>
            <div className="d-flex justify-content-end align-items-center mb-2">
              {/* <small className="text-muted">Select your seats on the map</small> */}
              <div className="d-flex align-items-center gap-2">

                <button className="btn btn-sm btn-primary" onClick={() => setShowSeatPrefModal(true)}>
                  <FontAwesomeIcon icon={faPencil} className="me-1" /> Choose Your Tickets
                </button>
              </div>
            </div>
            <div className='row '>
              {  /* Display chosen ticket preferences */}
              {ticketPrefs && Object.keys(ticketPrefs).length > 0 && (
                <div className="d-flex flex-wrap gap-1" style={{ marginBottom: '1.5rem' }}>
                  {Object.entries(ticketPrefs).map(([section, count]) => (
                    <span
                      key={section}
                      className="badge bg-primary-subtle border border-primary-subtle rounded-pill px-2 py-1"
                      style={{ fontSize: '0.75rem', fontWeight: '400', color: '#000' }}
                    >
                      {section}: {count} ticket{count > 1 ? 's' : ''}
                    </span>
                  ))}
                </div>
              )}
            </div>
            <div
              className="seat-map-container"
              style={{
                maxHeight: '70vh',
                overflowY: 'auto',
                overflowX: 'hidden',
                WebkitOverflowScrolling: 'touch',
                position: 'relative',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f1f1f1',
                borderRadius: '12px',
                marginBottom: '1rem'
              }}
            >
              {roundLayoutData && <img style={{ maxHeight: '55vh', margin: 'auto', display: 'flex' }} src={seatmapimg} />}
{!roundLayoutData && <CanvasSeatMapCanvas seatMapData={seats} selectedSeats={selectedSeats} toggleSeat={toggleSeat} />}

              {/* <img style={{maxHeight: '55vh', display: 'flex', margin:'auto'}} src={seatmapimg}></img> */}
              {/* <CanvasSeatMapCanvas 
                seatMapData={roundLayoutData || seats} 
                selectedSeats={selectedSeats} 
                toggleSeat={toggleSeat} 
              /> */}

              {/* Scroll indicator for mobile */}
              <style>{`
                .seat-map-container::-webkit-scrollbar {
                  width: 8px;
                }
                .seat-map-container::-webkit-scrollbar-track {
                  background: #f1f1f1;
                  border-radius: 10px;
                }
                .seat-map-container::-webkit-scrollbar-thumb {
                  background: #888;
                  border-radius: 10px;
                }
                .seat-map-container::-webkit-scrollbar-thumb:hover {
                  background: #555;
                }
                @media (max-width: 768px) {
                  .seat-map-container {
                    box-shadow: inset 0 -10px 10px -10px rgba(0,0,0,0.1);
                  }
                }
              `}</style>
            </div>
          </div>

          <div className="col-md-5 px-md-5 event-summary">
            <div className="card mb-4 shadow-sm border-0">
              <div className="row g-3 p-3 align-items-center">
                <div className="col-md-2 col-3">
                  <img src={image} alt={title} className="img-fluid rounded" />
                </div>
                <div className="col-md-10 col-9">
                  <h5 className="mb-1 fw-semibold">{title}</h5>
                  <small className="text-muted">
                    {/* {formatEventDateTime(eventData.datetime || datetime)} <span className="mx-2">|</span> */}
                    {typeof venue === 'string' ? venue : venue?.name || 'Venue TBA'}
                  </small>
                  
   </div>
              </div>
              
            </div>

                 <p style={{fontSize: '14px', opacity: .6}}>Please note that this seating plan is for illustration purpose only. The actual layout may vary depending on circumstances.</p>
             

            <div className="card shadow-sm border-0 selection-card-desktop">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowContactModal(true)}
                  >
                    Contact Us
                  </button>
                </div>
                <h5 className="card-title mb-3">Your Selection</h5>
                {/* {selectedSeatDetails.length > 0 ? (
                  <>
                    <ul className="list-group list-group-flush mb-3">
                      {selectedSeatDetails.map((seat) => {
                        const ticketType = seatTicketTypes[seat.id] || '';
                        const seatPrice = ticketType === 'child' && seat.childprice !== undefined && seat.childprice !== null
                          ? seat.childprice
                          : seat.price || 0;
                        return (
                          <li key={seat.id} className="list-group-item">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div>
                                {seat.isRoundLayout ? (
                                  <>
                                    <strong>{seat.tableName || seat.section}</strong> – {seat.label || seat.number || 'Seat'}<br />
                                    <small className="text-muted">Table Seat</small>
                                  </>
                                ) : (
                                  <>
                                    <strong>Row {seat.row}</strong> – Seat {seat.number}<br />
                                    <small className="text-muted">Section: {seat.section}</small>
                                  </>
                                )}
                              </div>
                              <span className="fw-semibold">£{seatPrice}</span>
                            </div>
                            <div className="mt-2">
                              <label className="form-label small mb-1">Ticket Type:</label>
                              <div className="d-flex gap-4">
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    className="form-check-input"
                                    name={`ticketType-${seat.id}`}
                                    id={`adult-${seat.id}`}
                                    value="adult"
                                    checked={ticketType === 'adult'}
                                    onChange={() => handleTicketTypeChange(seat.id, 'adult')}
                                  />
                                  <label className="form-check-label" htmlFor={`adult-${seat.id}`}>
                                    Adult - £{seat.price}
                                  </label>
                                </div>
                                {seat.childprice !== undefined && seat.childprice !== null && (
                                  <div className="form-check">
                                    <input
                                      type="radio"
                                      className="form-check-input"
                                      name={`ticketType-${seat.id}`}
                                      id={`child-${seat.id}`}
                                      value="child"
                                      checked={ticketType === 'child'}
                                      onChange={() => handleTicketTypeChange(seat.id, 'child')}
                                    />
                                    <label className="form-check-label" htmlFor={`child-${seat.id}`}>
                                      Child - £{seat.childprice}
                                    </label>
                                  </div>
                                )}
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">Total:</h5>
                      <h5 className="mb-0 text-primary">£{totalCost}</h5>
                    </div>
                    <div className="d-flex gap-2 justify-content-between pt-4">
                      <button className="btn btn-secondary" onClick={clearSelection}>Clear Selection</button>
                      <button className="btn btn-primary" onClick={handleConfirmBookingClick}>Confirm Booking</button>
                    </div>
                  </>
                ) : <p className="text-muted">No seats selected yet.</p>} */}
                {selectedSeatDetails.length > 0 && (
  <>
    <ul className="list-group list-group-flush mb-3">
      {Object.entries(
        selectedSeatDetails.reduce((acc, seat) => {
          const table = seat.tableName || seat.section || 'Unknown Table';
          if (!acc[table]) acc[table] = [];
          acc[table].push(seat);
          return acc;
        }, {})
      ).map(([table, seats]) => (
        <li key={table} className="list-group-item">
          <div className="mb-2">
            <strong>{table}</strong> – {seats.length} seat{seats.length > 1 ? 's' : ''}

            {/* <strong> {table?.trim().split(/\s+/)[0]}</strong> – {seats.length} seat{seats.length > 1 ? 's' : ''} */}
          </div>
          <div className="d-flex flex-column gap-2">
            {seats.map((seat, index) => {
              const ticketType = seatTicketTypes[seat.id] || 'adult';
              return (
                <div key={seat.id} className="d-flex gap-4 align-items-center">
                  {/* Show seat number only if more than 1 seat in table */}
                  {seats.length > 1 && <strong>Seat {index + 1}:</strong>}
                  <div className="form-check">
                    <input
                      type="radio"
                      className="form-check-input"
                      name={`ticketType-${seat.id}`}
                      id={`adult-${seat.id}`}
                      value="adult"
                      // checked={!seatTicketTypes[seat.id] || seatTicketTypes[seat.id] === 'adult'}
checked={seatTicketTypes[seat.id] === 'adult'}

                      // checked={ticketType === 'adult'}
                      // checked={!ticketType || ticketType === 'adult'}

                      onChange={() => handleTicketTypeChange(seat.id, 'adult')}
                    />
                    <label className="form-check-label" htmlFor={`adult-${seat.id}`}>
                      Adult - £{seat.price}
                    </label>
                  </div>
                  {seat.childprice !== undefined && seat.childprice !== null && (
                    <div className="form-check">
                      <input
                        type="radio"
                        className="form-check-input"
                        name={`ticketType-${seat.id}`}
                        id={`child-${seat.id}`}
                        value="child"
                        checked={ticketType === 'child'}
                        onChange={() => handleTicketTypeChange(seat.id, 'child')}
                      />
                      <label className="form-check-label" htmlFor={`child-${seat.id}`}>
                        Child - £{seat.childprice}
                      </label>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </li>
      ))}
    </ul>

    <div className="d-flex justify-content-between align-items-center mb-3">
      <h5 className="mb-0">Total:</h5>
      <h5 className="mb-0 text-primary">£{totalCost}</h5>
    </div>

    <div className="d-flex gap-2 justify-content-between pt-4">
      <button className="btn btn-secondary" onClick={clearSelection}>Clear Selection</button>
      <button className="btn btn-primary" onClick={handleConfirmBookingClick}>Confirm Booking</button>
    </div>
  </>
)}

              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center align-items-center mb-3 d-md-none d-block">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowContactModal(true)}
                  >
                    Contact Us
                  </button>
                </div>
      </section>
               
      

      <div className="modal fade" id="confirmModal" tabIndex="-1" aria-labelledby="confirmModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              {/* <h5 className="modal-title" id="confirmModalLabel">Please Confirm</h5> */}
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p><strong>Note:</strong><br></br> Please read the following before continuing:</p>
              <ul>
                <li>No cancellations or refunds allowed.</li>
                {/* <li>Please arrive 15 minutes before showtime.</li> */}
                <li>Ensure your seat selection is accurate.</li>
                {/* <li>Bring a valid photo ID to the venue.</li> */}
                {/* <li>Entry is restricted after the show starts.</li> */}
                {/* <li>Covid safety norms must be followed.</li> */}
              </ul>
              <small>
                Check out our <Link to="/terms-and-conditions">terms and conditions</Link> for more information.
              </small>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn btn-primary" onClick={confirmBooking}>Continue</button>
            </div>
          </div>
        </div>
      </div>

      {showSeatPrefModal && !showAuthModal && (
        <div className="modal fade show d-block choose-your-tickets-modal" tabIndex="-1" style={{ background: '#00000080' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Choose Your Tickets</h5>
                <button type="button" className="btn-close" onClick={() => {
                  setShowSeatPrefModal(false);
                  setSelectedBaseSection('');
                  setSelectedSection('');
                  setTicketCount(1);
                  setMaxTicketsForSection(0);
                }} aria-label="Close"></button>
              </div>
              <div className="modal-body">
                {availableSections.length > 0 ? (
                  <p>Choose your section and number of tickets:</p>
                ) : (
                  <div className="alert alert-warning" role="alert">
                    No sections are currently available for booking. All seats may be reserved or unavailable.
                  </div>
                )}
                
                {/* Radio buttons for base sections */}
                {availableSections.length > 0 && (
                  <div className="mb-4">
                    <label className="form-label fw-semibold">Select Section</label>
                    <div className="row g-2 mt-2">
                      {getUniqueBaseSections().map(baseSection => (
                        <div key={baseSection} className="col-md-4 col-6">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="baseSection"
                              id={`baseSection-${baseSection}`}
                              value={baseSection}
                              checked={selectedBaseSection === baseSection}
                              onChange={e => {
                                const baseSection = e.target.value;
                                setSelectedBaseSection(baseSection);
                                // Reset selected section and ticket count when base section changes
                                setSelectedSection('');
                                setTicketCount(1);
                                setMaxTicketsForSection(0);
                              }}
                            />
                            <label className="form-check-label" htmlFor={`baseSection-${baseSection}`}>
                              {baseSection}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                <div className="row align-items-end">
                  <div className="col-md-7 mb-3">
                    <label className="form-label fw-semibold">Select Row</label>
                    <select
                      className="form-select"
                      value={selectedSection}
                      onChange={e => {
                        const section = e.target.value;
                        console.log('Selected section:', section);
                        setSelectedSection(section);
                        if (section) {
                          const maxSeats = getAvailableSeatsCount(section);
                          setMaxTicketsForSection(maxSeats);
                          // Reset ticket count to 1 or max available if less than current
                          const currentCount = Number(ticketCount) || 1;
                          setTicketCount(Math.min(currentCount, maxSeats));
                          console.log('Max available seats for section:', maxSeats);
                        } else {
                          setMaxTicketsForSection(0);
                          setTicketCount(1);
                        }
                      }}
                      disabled={!selectedBaseSection}
                    >
                      <option value="">Select row</option>
                      {selectedBaseSection ? (
                        getSectionsForBaseSection(selectedBaseSection).map(section => {
                          const price = getSectionPrice(section);
                          const childprice = getSectionChildPrice(section);
                          const availableCount = getAvailableSeatsCount(section);
                          return (
                            <option key={section} value={section}>
                              {section} - (Adult £{price}, Child £{childprice}) ({availableCount} seats available)
                            </option>
                          );
                        })
                      ) : (
                        <option value="" disabled>Please select a section first</option>
                      )}
                    </select>
                  </div>
                  <div className="col-md-4 mb-md-3 mb-5 position-relative">
                    <label className="form-label fw-semibold">Tickets</label>
                    <input
                      type="number"
                      className="form-control"
                      min="1"
                      max={maxTicketsForSection || 1}
                      value={ticketCount}
                      onFocus={e => e.target.select()}
                      onChange={e => {
                        const inputValue = e.target.value;
                        const maxAllowed = maxTicketsForSection || 1;

                        // Allow empty string temporarily for better UX
                        if (inputValue === '') {
                          setTicketCount('');
                          return;
                        }

                        const value = Number(inputValue);

                        // Restrict value to be within range
                        if (value > maxAllowed) {
                          setTicketCount(maxAllowed);
                          console.log('Ticket count exceeds max, setting to:', maxAllowed);
                        } else if (value < 1) {
                          setTicketCount(1);
                        } else {
                          console.log('Setting ticket count:', value);
                          setTicketCount(value);
                        }
                      }}
                      onBlur={e => {
                        // If field is empty on blur, set to 1
                        if (e.target.value === '' || Number(e.target.value) < 1) {
                          setTicketCount(1);
                        }
                      }}
                      disabled={!selectedSection}
                    />
                    {selectedSection && maxTicketsForSection > 0 && (
                      <small className="text-muted position-absolute">Max: {maxTicketsForSection} available</small>
                    )}
                  </div>
                  <div className="col-md-4 mb-3">
                    <button
                      className="btn btn-primary w-100"
                      onClick={handleAddTicket}
                      disabled={!selectedBaseSection || !selectedSection || !ticketCount || Number(ticketCount) < 1 || Number(ticketCount) > maxTicketsForSection}
                    >
                      Add
                    </button>
                  </div>
                </div>
                <hr />

                <h6 className="fw-semibold">Your Selection:</h6>
                {(!ticketPrefs || Object.keys(ticketPrefs).length === 0) ? (
                  <p className="text-muted">No tickets selected yet.</p>
                ) : (
                  <ul className="list-group">
                    {Object.entries(ticketPrefs).map(([section, count]) => (
                      <li key={section} className="list-group-item d-flex justify-content-between align-items-center">
                        <span>{section}</span>
                        <span className="d-flex align-items-center">
                          {count}
                          <button
                            className="btn btn-sm btn-link text-danger ms-2"
                            onClick={() => handleRemoveTicket(section)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowSeatPrefModal(false);
                    setSelectedBaseSection('');
                    setSelectedSection('');
                    setTicketCount(1);
                    setMaxTicketsForSection(0);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handlePrefsSave}
                  disabled={!ticketPrefs || Object.keys(ticketPrefs).length === 0}
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Authentication Modal - Always rendered but conditionally shown */}
      <div
        className={`modal fade ${showAuthModal ? 'show d-block' : ''}`}
        id="bookingAuthModal"
        tabIndex="-1"
        aria-labelledby="authModalLabel"
        aria-hidden="true"
        style={showAuthModal ? { background: '#00000080', display: 'block' } : { display: 'none' }}
      >
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <h5 className="modal-title" id="authModalLabel">Login Required</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowAuthModal(false);
                  setPendingConfirmation(false);
                }}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="text-center mb-4">
                <p className="text-muted">Please log in or create an account to continue with your booking.</p>
              </div>
              <Form onLoginSuccess={handleLoginSuccess} />
            </div>
          </div>
        </div>
      </div>

      {/* Contact Us Modal */}
      {showContactModal && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ background: '#00000080' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Contact Us</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowContactModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <p>For any queries regarding booking please WhatsApp/call:</p>
                <div className="d-flex justify-content-between gap-3">
                  <a
                    href="https://wa.me/447884874463"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success d-flex align-items-center justify-content-center"
                    style={{ textDecoration: 'none', padding: '12px' }}
                  >
                    <FontAwesomeIcon icon={faWhatsapp} className="me-2" style={{ fontSize: '1.5rem' }} />
                    <span>+44 7884874463</span>
                  </a>
                  <a
                    href="https://wa.me/447780068830"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success d-flex align-items-center justify-content-center"
                    style={{ textDecoration: 'none', padding: '12px' }}
                  >
                    <FontAwesomeIcon icon={faWhatsapp} className="me-2" style={{ fontSize: '1.5rem' }} />
                    <span>+44 7780068830</span>
                  </a>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowContactModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Selection Panel - Mobile only */}
      {isMobile && selectedSeatDetails.length > 0 && (
        <div className={`mobile-selection-panel ${isMobilePanelExpanded ? 'expanded' : 'collapsed'}`}>
          <div 
            className="mobile-selection-header"
            onClick={() => setIsMobilePanelExpanded(!isMobilePanelExpanded)}
            style={{ cursor: 'pointer' }}
          >
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                <h6 className="mb-0">Your Selection ({selectedSeatDetails.length})</h6>
                {!isMobilePanelExpanded && (
                  <small className="text-muted">Tap to view details</small>
                )}
              </div>
              <div className="d-flex align-items-center gap-2">
                <div className="fw-bold text-primary">£{totalCost}</div>
                <FontAwesomeIcon 
                  icon={isMobilePanelExpanded ? faChevronDown : faChevronUp} 
                  className="text-muted"
                  style={{ fontSize: '0.9rem' }}
                />
              </div>
            </div>
          </div>
          
          <div className="mobile-selection-content">
            {selectedSeatDetails.map((seat) => {
              const ticketType = seatTicketTypes[seat.id] || ''; // Don't default to 'adult' - leave empty if not selected
              const seatPrice = ticketType === 'child' && seat.childprice !== undefined && seat.childprice !== null
                ? seat.childprice
                : ticketType === 'adult' || ticketType === ''
                  ? seat.price || 0
                  : seat.price || 0;
                  const groupKey = seat.tableId || seat.tableName || seat.section;

const groupSeats = selectedSeatDetails.filter(
  s => (s.tableId || s.tableName || s.section) === groupKey
);

const isFirstSeat =
  selectedSeatDetails.findIndex(
    s => (s.tableId || s.tableName || s.section) === groupKey
  ) === selectedSeatDetails.indexOf(seat);

              return (
                <div key={seat.id} className="mobile-seat-item">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      {seat.isRoundLayout ? (
                        <>
                          {/* <strong>{seat.tableName || seat.section} – {seat.label || seat.number || 'Seat'}</strong> */}
                          {/* <strong>
  {seat.tableName || seat.section} –{' '}
  {
    selectedSeatDetails.filter(
      s =>
        (s.tableId || s.tableName || s.section) ===
        (seat.tableId || seat.tableName || seat.section)
    ).length
  }{' '}
  Seat
  {
    selectedSeatDetails.filter(
      s =>
        (s.tableId || s.tableName || s.section) ===
        (seat.tableId || seat.tableName || seat.section)
    ).length > 1
      ? 's'
      : ''
  } */}
{/* </strong> */}
{isFirstSeat && (
  <strong>
    {seat.tableName || seat.section} – {groupSeats.length}{' '}
    Seat{groupSeats.length > 1 ? 's' : ''}
  </strong>
)}

                          <br />
                          {/* <small className="text-muted">Table Seat</small> */}
                        </>
                      ) : (
                        <>
                          <strong>Row {seat.row}, Seat {seat.number}</strong>
                          <br />
                          <small className="text-muted">{seat.section}</small>
                        </>
                      )}
                    </div>
                    <span className="fw-semibold">
                      {ticketType ? `£${seatPrice}` : 'Select type'}
                    </span>
                  </div>
                  <div className="mt-2">
                    <label className="form-label small mb-1 fw-semibold">Ticket Type:</label>
                    <div className="d-flex gap-3">
                      <div className="form-check flex-fill">
                        <input
                          type="radio"
                          className="form-check-input"
                          name={`mobile-ticketType-${seat.id}`}
                          id={`mobile-adult-${seat.id}`}
                          value="adult"
                          checked={ticketType === 'adult'}
                          onChange={() => handleTicketTypeChange(seat.id, 'adult')}
                        />
                        <label className="form-check-label" htmlFor={`mobile-adult-${seat.id}`}>
                          Adult - £{seat.price}
                        </label>
                      </div>
                      {seat.childprice !== undefined && seat.childprice !== null && (
                        <div className="form-check flex-fill">
                          <input
                            type="radio"
                            className="form-check-input"
                            name={`mobile-ticketType-${seat.id}`}
                            id={`mobile-child-${seat.id}`}
                            value="child"
                            checked={ticketType === 'child'}
                            onChange={() => handleTicketTypeChange(seat.id, 'child')}
                          />
                          <label className="form-check-label" htmlFor={`mobile-child-${seat.id}`}>
                            Child - £{seat.childprice}
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          
          <div className="mobile-selection-footer">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="fw-semibold">Total:</span>
              <span className="fw-bold text-primary" style={{ fontSize: '1.2rem' }}>£{totalCost}</span>
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-secondary flex-fill" onClick={clearSelection}>
                Clear Selection
              </button>
              <button className="btn btn-primary flex-fill" onClick={handleConfirmBookingClick}>
                Confirm Booking
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Floating scroll button - Mobile only */}
      {isMobile && (
        <button
          onClick={handleScrollClick}
          aria-label={scrollDirection === 'down' ? 'Scroll down' : 'Scroll up'}
          style={{
            position: 'fixed',
            bottom: selectedSeatDetails.length > 0 ? (isMobilePanelExpanded ? '100px' : '100px') : '30px',
            right: '20px',
            width: '45px',
            height: '45px',
            borderRadius: '50%',
            backgroundColor: '#007bff',
            border: 'none',
            color: 'white',
            fontSize: '18px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(0, 123, 255, 0.4)',
            zIndex: 9998,
            WebkitTapHighlightColor: 'transparent',
            transition: 'bottom 0.3s ease'
          }}
          className="floating-scroll-btn"
        >
          <FontAwesomeIcon icon={scrollDirection === 'down' ? faChevronDown : faChevronUp} style={{ fontSize: '18px' }} />
        </button>
      )}

      <style>{`
        .floating-scroll-btn:active {
          transform: scale(0.9);
          opacity: 0.8;
        }
        
        /* Mobile Selection Panel Styles */
        .mobile-selection-panel {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: white;
          border-top: 2px solid #e9ecef;
          box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
          z-index: 1000;
          display: flex;
          flex-direction: column;
          animation: slideUp 0.3s ease-out;
          transition: max-height 0.3s ease-out;
        }
        
        .mobile-selection-panel.expanded {
          max-height: 70vh;
        }
        
        .mobile-selection-panel.collapsed {
          max-height: 160px;
          margin-bottom: 1rem;
        }
        
        @keyframes slideUp {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        
        .mobile-selection-header {
          padding: 15px;
          border-bottom: 1px solid #e9ecef;
          background: #f8f9fa;
          transition: background-color 0.2s ease;
        }
        
        .mobile-selection-header:active {
          background-color: #e9ecef;
        }
        
        .mobile-selection-content {
          flex: 1;
          overflow-y: auto;
          padding: 15px;
          -webkit-overflow-scrolling: touch;
          transition: opacity 0.2s ease;
        }
        
        .mobile-selection-panel.collapsed .mobile-selection-content {
          display: none;
        }
        
        .mobile-selection-footer {
          transition: opacity 0.2s ease;
        }
        
        .mobile-seat-item {
          padding: 12px;
          margin-bottom: 12px;
          background: #f8f9fa;
          border-radius: 8px;
          border: 1px solid #e9ecef;
        }
        
        .mobile-seat-item:last-child {
          margin-bottom: 0;
        }
        
        .mobile-selection-footer {
          padding: 15px;
          border-top: 1px solid #e9ecef;
          background: white;
        }
        
        .mobile-selection-panel .form-check-input {
          margin-top: 0.3rem;
        }
        
        .mobile-selection-panel .form-check-label {
          font-size: 0.9rem;
          cursor: pointer;
          padding-left: 0.5rem;
        }
        
        /* Adjust body padding when panel is open */
        .has-mobile-sticky-buttons {
          padding-bottom: 0;
        }
      `}</style>
    </>
  );
};

export default BookingPage;

